export default {
  name: "E808D2Triangle",
  props: {
    colors: {
      type: String,
      default: 'BGRGRBBXZY'
    }
  },
  data() {
    return {
      flags: {
        'X': '+',
        'Y': '÷',
        'Z': '÷'
      },
      color: {
        'R': 'red',
        'G': 'green',
        'B': 'blue'
      }
    };
  },
  methods: {
    firstColor() {
      for (let c of this.colors) {
        if (c != '?') {
          return this.color[c];
        }
      }
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};